<div class="inline-select">
    <button
        [disabled]="disabled()"
        [ngStyle]="styles().links"
        class="aix-btn aix-btn--link br-link inline-select__menu-button"
        [data-testing]="'manage-button'"
        type="button"
    >
        {{ selectedOption?.label }}<span class="fa-solid fa-caret-down u-ml8"></span>
    </button>
    @if (!disabled()) {
    <ul class="inline-select-menu aix-flex-grid aix-flex-grid__col">
        @for (element of options(); track element.label) {
        <li>
            <button
                class="aix-btn aix-btn--link br-link"
                [attr.data-testing]="element.label.toLowerCase() + '-button'"
                (click)="optionClicked(element)"
                [ngStyle]="styles().links"
                type="button"
            >
                {{ element.label }}
            </button>
        </li>
        }
    </ul>
    }
</div>
